import { render, staticRenderFns } from "./FormItemImg.vue?vue&type=template&id=be4e2c5c&scoped=true&"
import script from "./FormItemImg.vue?vue&type=script&lang=js&"
export * from "./FormItemImg.vue?vue&type=script&lang=js&"
import style0 from "./FormItemImg.vue?vue&type=style&index=0&id=be4e2c5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4e2c5c",
  null
  
)

export default component.exports